import { defineComponent as _defineComponent } from 'vue'
import { ClientOnboardingReport, ComplianceStatus } from 'ah-api-gateways';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { BModal } from 'bootstrap-vue';
import { PropType, computed, ref } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useServices } from 'bd-common/src/services';
import DropdownMenu, { DropdownMenuItem } from 'bd-common/src/components/common/DropdownMenu.vue';
import { mergeMap } from 'rxjs/operators';
import { waitForCQRSEntityChange } from '../../../../../../packages/ah-requests/helpers/wait';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardedClientActionsMenu',
  props: {
  onboardedClient: {
    type: Object as PropType<ClientOnboardingReport>,
    required: true,
  },
},
  emits: {
  confirm: () => true,
},
  setup(__props, { emit }) {

const props = __props;



const services = useServices();

const requestManager = useRequestManager().manager;

const iconRef = ref<InstanceType<typeof MaterialIcon>>();

const clientName = computed(
  () => `${props.onboardedClient.applicant?.firstName ?? ''} ${props.onboardedClient.applicant?.lastName ?? ''}`
);



const modalShown = ref<boolean>(false);

function suspendClient() {
  return requestManager
    .currentOrNew(
      'updateStatus',
      services.client
        .updateClientOnboardingStatus(props.onboardedClient.id, ComplianceStatus.SUSPENDED)
        .pipe(
          mergeMap((idEntity) =>
            waitForCQRSEntityChange(idEntity, () => services.client.getClient(props.onboardedClient.id))
          )
        )
    )
    .subscribe(() => {
      emit('confirm');
      hideSuspendModal();
    });
}

function showSuspendModal() {
  modalShown.value = true;
}

function hideSuspendModal() {
  modalShown.value = false;
}

const menuItems: DropdownMenuItem[] = [
  {
    label: 'Suspend Client',
    name: 'suspend-client',
    action: () => showSuspendModal(),
  },
];

return { __sfc: true,props, services, requestManager, iconRef, clientName, emit, modalShown, suspendClient, showSuspendModal, hideSuspendModal, menuItems, MaterialIcon, BModal, DropdownMenu }
}

})